/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { type MessageDescriptor, defineMessage } from '@atlassian/jira-intl';
import { TEAM_NAME, BOARD_CREATE_PACKAGE_NAME, BOARD_TYPES } from './boardTypes.constants.tsx';

const scrumBoardCreationDescription = defineMessage({
	id: 'software-board-create.common.scrum-board-creation-description',
	defaultMessage: 'Sprint towards your team objectives with a board, backlog, and reports.',
	description:
		'The description for both the scrum board creation option in the board creation flyout menu and the modal that opens after the user has made a selection. In the modal, this appears under the boardCreationTitle',
});

const kanbanBoardCreationDescription = defineMessage({
	id: 'software-board-create.common.kanban-board-creation-description',
	defaultMessage: 'Manage a continuous delivery of work with a kanban board and reports.',
	description:
		'The description for both the kanban board creation option in the board creation flyout menu and the modal that opens after the user has made a selection. In the modal, this appears under the boardCreationTitle',
});

type Props = {
	attributes?: {
		[key: string]: string | number | undefined | null;
	};
	id: string;
	error: Error;
};

export const fireBoardCreateErrorAnalytics = ({ attributes, id, error }: Props): void => {
	fireErrorAnalytics({
		error,
		attributes,
		meta: {
			id: `jiraSoftwareBoardCreate_${id}`,
			packageName: BOARD_CREATE_PACKAGE_NAME,
			teamName: TEAM_NAME,
		},
		skipSentry: true,
	});
};

export const descriptionMapping: { [key: string]: MessageDescriptor } = {
	[BOARD_TYPES.KANBAN]: kanbanBoardCreationDescription,
	[BOARD_TYPES.SCRUM]: scrumBoardCreationDescription,
};
